import _ from "lodash";

import { mapState } from "vuex";
import TeamCard from "@/components/Teams/Card";
import EnrollmentCard from "@/components/Enrollments/Card";

import TeamEditor from "@/components/Teams/Editor";

import Team from "@/services/Team";
import Enrollment from "@/services/Enrollment";
import Event from "@/services/Event";

import getCurrentSeason from "@/helpers/events/getCurrentSeason";
import getPossibleSeasons from "@/helpers/events/getPossibleSeasons";

import ParseHTTPError from "@/helpers/ParseHTTPError";

import getPossibleStages from "@/helpers/events/getPossibleStages";

export default {
  name: "Home",

  data() {
    return {
      // Load flags
      loadingTeams: false,
      loadingEnrollments: true,

      teams: [],

      enrollments: [],

      events: [],

      selectedSeason: null,
    };
  },

  components: {
    TeamCard,
    EnrollmentCard,
    TeamEditor,
  },

  computed: {
    ...mapState(["isJudge", "community"]),

    filteredEnrollments() {
      return this.enrollments.filter((e) =>
        this.seasonEventsIds.includes(e.event._id),
      );
    },

    possibleSeasons() {
      return getPossibleSeasons(this.community);
    },

    season() {
      return (
        (this.selectedSeason && this.selectedSeason._id) ||
        getCurrentSeason(this.community)
      );
    },

    tournamentStages() {
      return _.map(getPossibleStages(this.community), "kind");
    },

    seasonEventsIds() {
      return this.events
        .filter((event) => _.get(event, "event.season._id") == this.season)
        .map((e) => e._id);
    },
  },

  created() {
    // Fetch my teams
    this.fetchTeams();

    this.fetchEvents();

    this.selectedSeason = getCurrentSeason(this.community);
  },

  methods: {
    createTeam() {
      this.$dialog(
        {
          width: this.$vuetify.breakpoint.xsOnly ? "95%" : "608px",
          closeOnClickModal: false,
        },
        TeamEditor,
      )
        .then(() => {
          this.fetchTeams();
        })
        .catch(() => {});
    },

    editTeam(team) {
      if (!_.get(team, "_id")) {
        return;
      }

      this.$dialog(
        {
          width: this.$vuetify.breakpoint.xsOnly ? "95%" : "608px",
          cache: team,
          modelId: team._id,
          closeOnClickModal: false,
        },
        TeamEditor,
      )
        .then(() => {
          this.fetchTeams();
          this.fetchEnrollments();
        })
        .catch(() => {});
    },

    fetchTeams() {
      this.loadingTeams = true;

      Team.list().then(
        (res) => {
          this.loadingTeams = false;
          this.teams = res.data;
        },
        (err) => {
          this.loadingTeams = false;
          const status = ParseHTTPError(err);
          let { error } = status;

          if (!status.type) {
            error =
              "Houve um erro na comunicação com o servidor, tente novamente";
          }

          this.$notify.error({
            title: "Erro",
            message: error,
          });
        },
      );
    },

    createEnrollment() {
      this.$router.push({ name: "registration" });
    },

    fetchEnrollments() {
      this.loadingEnrollments = true;

      Enrollment.list({
        kind: this.isJudge ? "judge" : "team",
      }).then(
        (res) => {
          this.loadingEnrollments = false;

          this.enrollments = res.data.reverse();
        },
        (err) => {
          this.loadingEnrollments = false;
          const status = ParseHTTPError(err);
          let { error } = status;

          if (!status.type) {
            error =
              "Houve um erro na comunicação com o servidor, tente novamente";
          }

          this.$notify.error({
            title: "Erro",
            message: error,
          });
        },
      );
    },

    fetchEvents() {
      Event.list({ "event.kind": this.tournamentStages }).then(
        (res) => {
          this.events = res.data;
          this.fetchEnrollments();
        },
        () => {},
      );
    },

    editEnrollment(enrollment) {
      if (!_.get(enrollment, "_id")) {
        return;
      }

      this.$router.push({
        name: "submit",
        params: {
          cache: enrollment,
          modelId: enrollment._id,
          kind: enrollment.kind,
        },
      });
    },

    updateMe() {
      this.$router.push({
        name: "signup",
        params: { community: this.community },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js